import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { ISearchCustomerResponse, ISearchCustomerResponseData } from "@/api_framework/api_modals/Users";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

import { setCustomerSearchResults } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useSearchCustomerAPI = () => {
  const configuration = useConfiguration();
  const [searchResults, setSearchResults] = useState<ISearchCustomerResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const latestRequestIdRef = useRef(0);
  const toggleLoadingState = (toggleState: boolean) => {
    dispatch(setLoading({ key: "isCustomerSearchInProgress", status: toggleState }));
  };

  const memorizedSearchResults = useMemo(() => {
    return searchResults;
  }, [searchResults]);

  const execute = useCallback(
    async (query: string, toggle: "0" | "1", clinic_id?: string) => {
      const requestId = ++latestRequestIdRef.current;
      const isLatestRequest = () => requestId === latestRequestIdRef.current;
      toggleLoadingState(true);
      localStorage.setItem("selectedPetId", null);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ISearchCustomerResponseData[] = await axios
          .get(CUSTOMER_APIS?.SEARCH_CUSTOMER?.baseURL ?? "", {
            params: {
              search_text: query,
              search_toggle: toggle,
              clinic_id: clinic_id,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ISearchCustomerResponse>) => {
            if (!isLatestRequest()) {
              return res.data.status === true ? res.data.data : null;
            }
            toggleLoadingState(false);

            if (res.data.status === true) {
              setSearchResults(res.data.data);
              dispatch(
                setCustomerSearchResults({
                  searchResults: res.data.data,
                }),
              );
              return res.data.data;
            } else if (res.data.status === false) {
              // If not data has been found
              setSearchResults([]);
              dispatch(
                setCustomerSearchResults({
                  searchResults: [],
                }),
              );
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config?.["curlCommand"]);
            if (!isLatestRequest()) return null;
            toggleLoadingState(false);
            if (e.response?.status === 400) {
              setSearchResults([]);
              dispatch(
                setCustomerSearchResults({
                  searchResults: [],
                }),
              );
            }
            if (e.code === "ERR_BAD_RESPONSE") {
              toast.error("Customer search API failed.");
            }
            if (e.code === "ERR_CONNECTION_TIMED_OUT") {
              toast.error("Connection timeout");
            }
            return null;
          });
        return response;
      } catch (e: any) {
        if (!isLatestRequest()) return null;
        toggleLoadingState(false);
        toast.error("Search API Failed: " + e.message);
        return null;
      }
    },
    [dispatch],
  );
  return { searchResults: memorizedSearchResults, execute };
};
